import { POSTALCODE_FILTER_EVENTS, TPostalCodeFilterToggle, TPostalCodeSelection } from './index';
import i18n, { defaultLang } from '@src/i18n';
import { trackByEvent } from '@src/tracking/services';
import { COMPONENT_TYPE } from '@src/tracking/constant';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
export const usePostalCodeFilterTracking = () => {
  const { restaurant } = useKeycloakUserState();
  const trackPostalCodeFilterToggle = () => {
    const { map_action, component_name, component_type, event } =
      POSTALCODE_FILTER_EVENTS.POSTALCODE_FILTER_TOGGLE;
    trackByEvent<TPostalCodeFilterToggle>('', {
      country: restaurant?.country || '',
      language: i18n.language || defaultLang,
      map_action,
      component_name,
      component_type: component_type as COMPONENT_TYPE,
      eventCategory: '',
      event,
    });
  };

  const trackPostalCodeSelection = () => {
    const { map_action, component_name, component_type, event } =
      POSTALCODE_FILTER_EVENTS.POSTALCODE_SELECTION;
    trackByEvent<TPostalCodeSelection>('', {
      country: restaurant?.country || '',
      language: i18n.language || defaultLang,
      map_action,
      component_name,
      component_type: component_type as COMPONENT_TYPE,
      eventCategory: '',
      event,
    });
  };

  return {
    trackPostalCodeFilterToggle,
    trackPostalCodeSelection,
  };
};
